/**
 * Spatial Explorer Feature Module (T16)
 *
 * Registers the spatial-explorer workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the spatial-explorer workspace component
registerWorkspaceComponent(
  'spatial-explorer',
  lazyWorkspaceTab(() => import('./components/SpatialExplorerTab').then((m) => ({ default: m.SpatialExplorerTab }))),
);

// Re-export components
export { SpatialLayersPanel } from './components/SpatialLayersPanel';
export { SpatialFeatureInspector } from './components/SpatialFeatureInspector';
export { SpatialAddLayerDialog } from './components/SpatialAddLayerDialog';

// Re-export store reducers (T17 session work reuses these)
export * from './store/spatialExplorerActions';
